export default class Common {
	private scrollToBottomThreshold: number = 20;

	private modalLicenseDialogSelector = '#modalLicense';
	private modalLicenseDialogBodySelector = '#modalLicense .modal-body';
	private licenseAgreementReadSelector = '#agreementRead';
	private licenseAgreementAcceptedSelector = '#agreementAccepted';
	private btnSubmitSelector = '#btnSubmit';

	private $form: JQuery<HTMLElement>;
	private $formValidator: JQueryValidation.Validator;
	private $agreementReadCheckBox: JQuery<HTMLElement>;
	private $agreementAcceptedCheckBox: JQuery<HTMLElement>;
	private $submitButton: JQuery<HTMLElement>;


	public constructor(formName: string) {
		this.$form = $(formName);
		this.$formValidator = this.$form.data('validator');
		this.$agreementAcceptedCheckBox = $(this.licenseAgreementAcceptedSelector);
		this.$agreementReadCheckBox = $(this.licenseAgreementReadSelector);
		this.$submitButton = $(this.btnSubmitSelector);

		this.$agreementAcceptedCheckBox.click((event) => this.clickAgreementCheckBox(event));

		$(this.modalLicenseDialogSelector).on('show.bs.modal', (event) => this.onShowLicenseDialog(event));
		$(this.modalLicenseDialogSelector).on('hide.bs.modal', (event) => this.onHideLicenseDialog(event));
		$(this.modalLicenseDialogBodySelector).scroll((event) => this.scrollToBottom(event));
		this.$form.submit((event) => this.onFormSubmit(event));
	}

	private scrollToBottom(event): void {
		const isScrolledToBottom: boolean = (event.target.scrollHeight - event.target.offsetHeight) <= event.target.scrollTop + this.scrollToBottomThreshold;

		if (isScrolledToBottom) {
			this.$agreementReadCheckBox.removeAttr('disabled');
		}
	}

	private onFormSubmit(event: JQuery.Event) {
		const isValid = this.$formValidator.element(this.$agreementAcceptedCheckBox);

		if (!isValid) {
			event.preventDefault();
		}
	}

	private clickAgreementCheckBox(event: JQuery.Event): void {
		this.updateAgreementCheckState(this.$agreementAcceptedCheckBox.is(':checked'));
	}

	private updateAgreementCheckState(isChecked: boolean) {
		if (isChecked) {
			this.$agreementAcceptedCheckBox.parent().popover('disable');
			this.$submitButton.removeAttr('disabled');

			if ($("#signUpForm").length !== 0 && $("#signUpForm").valid() === false) {
				this.$submitButton.prop('disabled', 'true');
			}
		}
		else {
			this.$agreementAcceptedCheckBox.parent().popover('enable');
			this.$submitButton.prop('disabled', 'true');
		}

		if (!!this.$formValidator) {
			// we need to revalidate a form
			this.$formValidator.resetForm();

			// we need to say validator again about this checkbox
			this.$formValidator.element(this.$agreementAcceptedCheckBox);
		}
	}

	private onShowLicenseDialog(event: JQuery.Event): void {
		// if agreement is already accepted then we need to update checkbox in popup
		this.$agreementReadCheckBox.prop('checked', this.$agreementAcceptedCheckBox.is(':checked'));

		if (this.$agreementReadCheckBox.is(":checked")) {
			this.$agreementReadCheckBox.removeAttr("disabled");
		}
	}

	private onHideLicenseDialog(event: JQuery.Event): void {
		// if agreement is already accepted then we need to update checkbox in the form
		this.$agreementAcceptedCheckBox.prop('checked', this.$agreementReadCheckBox.is(':checked'));

		this.updateAgreementCheckState(this.$agreementAcceptedCheckBox.is(':checked'));

		if (!this.$agreementReadCheckBox.is(':disabled')) {
			this.$agreementAcceptedCheckBox.removeAttr('disabled');
		}
	}
}



// WEBPACK FOOTER //
// ./Client/Scripts/models/common.ts